module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/SD-card-47c03955f6e9f12ddb3d0020263bf577.svg";